<template>
	<v-app>
		<nav-bar></nav-bar>

		<v-content>
			<v-scale-transition leave-absolute>
				<router-view></router-view>
			</v-scale-transition>
		</v-content>
	</v-app>
</template>

<script>
import NavBar from "./components/NavBar";
export default {
	name: "App",

	components: {
		NavBar
	},

	data: () => ({
		//
	})
};
</script>
